(function employeeFileMassiveImportFindControllerDefinition() {
    'use strict';

    angular.module('EmployeeFileMassiveImport')
        .controller('EmployeeFileMassiveImportFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processService', 'configViewService', '$translate', 'storageService', 'fileWorkflowService', 'fileDownloader',
            function employeeFileMassiveImportFindController($q, $filter, $scope, $state, errors, processService, configViewService, $translate, storageService, fileWorkflowService, fileDownloader) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return processService.advancedGet(filters).then(function (result) {
                        $scope.employeeFileMassiveImportsItems = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    r.metadatas.push({ value: metadataFound[0].value, type: metadataFound[0].type, description: metadataFound[0].description });
                                } else {
                                    r.metadatas.push({ value: null, type: null });
                                }
                            });

                            $scope.employeeFileMassiveImportsItems.push(r);
                        });
                        if ($scope.employeeFileMassiveImportsItems.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.employeeFileMassiveImportsItems.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.employeeFileMassiveImportFind.$valid) {
                        $scope.employeeFileMassiveImportFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setEmployeeFileMassiveImportsFilter($scope.find);

                    $scope.executeFind();
                }

                $scope.add = function () {
                    $state.go('employee-file-massive-import-add');
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                }

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearEmployeeFileMassiveImportsFilter();
                    $scope.find = storageService.getEmployeeFileMassiveImportsFilter();

                    $scope.employeeFileMassiveImportsItems = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.employeeFileMassiveImportsItems.forEach(function (employeeFileMassiveImport) {
                        var accordionIsOpen = false;
                        Object.defineProperty(employeeFileMassiveImport, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.employeeFileMassiveImportsItems = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }

                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }

                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    })

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        configViewService.getById("CPPEmployeeFileMassiveImport").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.downloadAllFiles = function () {
                    var files = [];

                    $scope.employeeFileMassiveImportsItems.forEach(function (employeeFileMassiveImport) {
                        employeeFileMassiveImport.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });
                    });

                    return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                        var success = fileDownloader.saveAs(result.value, $translate.instant('EmployeeFileMassiveImportAllFiles') + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.downloadFile = function (employeeFileMassiveImport) {
                    var file = employeeFileMassiveImport.files[0];

                    return fileWorkflowService.downloadFile(file.id).then(function (result) {

                        var success = fileDownloader.saveAs(result, file.name);

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.exportToExcel = function () {
                    return $translate(['ProcessReceptionDateView', 'ProcessImportFileName', 'ProcessState'])
                        .then(function (translated) {
                            var headers = [];

                            headers.push({ key: "CreationDate", value: translated.ProcessReceptionDateView });
                            headers.push({ key: "Name", value: translated.ProcessImportFileName });
                            headers.push({ key: "StateName", value: translated.ProcessState });

                            var filters = $scope.createFilters();

                            filters.itemPerPage = null;
                            filters.page = null;

                            return processService.exportToXLS(filters, headers, 'AltaMasiva').then(function (result) {
                                var d = new Date();

                                var docName = "AltaMasiva";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 403) {
                                    errors.showError('FileForbidden');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                };

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.find = storageService.getEmployeeFileMassiveImportsFilter();

                    $q.all([$scope.loadViewOptions()]).then(function (result) {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    });
                };

                $scope.load();
            }]);
})();